<app-header></app-header>

<h1 class="main-title">Privacy and Cookie Policy</h1>

<div class="container container__short">
  <app-legal-navbar></app-legal-navbar>
</div>

<div class="container container__short">
  <app-static-content [contentId]="'privacy-policy'" [showHeader]="false" [size]="-3"></app-static-content>
</div>

<app-footer></app-footer>